module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-container container"
  }, [_c('div', {
    staticClass: "menu",
    class: [_vm.menuOpenClass, {
      'is-transitioning': _vm.menu.isTransitioning
    }],
    on: {
      "transitionend": function($event) {
        _vm.menu.isTransitioning = false
      }
    }
  }, [_c('div', {
    staticClass: "menu__inner",
    class: _vm.menuOpenClass
  }, _vm._l((_vm.links), function(link) {
    return _c('router-link', {
      key: link.path,
      staticClass: "menu__link",
      class: [_vm.menuOpenClass, _vm.pathIsRootClass],
      attrs: {
        "to": link.path
      }
    }, [_vm._v("\n        " + _vm._s(link.text)), (link.path === '/work') ? _c('sup', {
      staticClass: "menu__work-count"
    }, [_vm._v("(" + _vm._s(_vm.projects.length) + ")")]) : _vm._e()])
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__logo",
    class: [_vm.menuOpenClass, {
      'is-black': !_vm.pathIsRoot
    }],
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_vm._v("\n    Thank You For Clapping\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "menu__links"
  }, _vm._l((_vm.links), function(link) {
    return _c('router-link', {
      key: link.path,
      staticClass: "menu__item",
      class: [_vm.menuItemClass],
      attrs: {
        "to": link.path === _vm.$route.path ? '/' : link.path
      }
    }, [_vm._v("\n      " + _vm._s(link.text)), (link.path === '/work') ? _c('sup', {
      staticClass: "menu__work-count"
    }, [_vm._v("(" + _vm._s(_vm.projects.length) + ")")]) : _vm._e()])
  })), _vm._v(" "), _c('button', {
    staticClass: "menu__button hamburger hover",
    class: [_vm.menuOpenClass, {
      'is-black': !_vm.pathIsRoot
    }],
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "hamburger__inner"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d074a07!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 388
// module chunks = 2